class d {
  constructor() {
  }
  validate(l, r, c) {
    const e = l.split("-");
    let t = "";
    switch (c) {
      //YMD > DMY
      case "hu":
      case "jp":
      case "hk":
      case "kr":
      case "tw":
      case "lt":
        t = `${e[2]}-${e[1]}-${e[0]}`;
        break;
      //MDY > DMY
      case "us":
      case "ph":
        t = `${e[1]}-${e[0]}-${e[2]}`;
        break;
      //DMY
      default:
        t = l;
        break;
    }
    if (t.match(/^(((0[1-9]|[12][0-9]|3[01])-(0[13578]|1[02])-((19|[2-9][0-9])[0-9]{2}))|((0[1-9]|[12][0-9]|30)-(0[13456789]|1[012])-((19|[2-9][0-9])[0-9]{2}))|((0[1-9]|1[0-9]|2[0-8])-02-((19|[2-9][0-9])[0-9]{2}))|(29-02-((1[6-9]|[2-9][0-9])(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/)) {
      let a = /* @__PURE__ */ new Date();
      a.setFullYear(a.getFullYear() - r);
      let s = t.split("-"), i = new Date(s[2], s[1] - 1, s[0]);
      if (a.getTime() >= i.getTime())
        return !0;
    }
    return !1;
  }
}
export {
  d as default
};
